import { FaGithub, FaFacebookSquare, FaLinkedin } from 'react-icons/fa';
import { FaSquareXTwitter } from 'react-icons/fa6';

export const data = [
  {
    title: 'Interactive Real Estate (WP plugin)',
    githubURL: 'https://github.com/esaia/interactive-real-estate',
    websiteURL: 'https://interactive-real-estate.vercel.app/',
    skills: ['php', 'WP plugin', 'Vue 3', 'Tailwind css'],
    description:
      'Interactive Real Estate is the most innovative WordPress plugin for creating interactive buildings and property displays. You can easily draw and edit complex shapes on your image right in the editor, without needing any external programs like Illustrator and create any kind of polygon shapes.',
  },

  {
    title: 'Airbnb Clone 2.0 (React Native)',
    githubURL: 'https://github.com/esaia/Airbnb-clone-react-native',
    // websiteURL: 'https://youtube.com/shorts/IldeZgbiOJw?feature=share',
    skills: ['React Native', 'expo router', 'react-native-reanimated', 'Tailwind css', 'Clerk auth'],
    description:
      'An Airbnb clone built with React Native, TypeScript, and Expo. This app allows users to browse apartments, update their profiles, and enjoy smooth animations using react-native-reanimated.',
  },

  {
    title: 'Bible App',
    githubURL: 'https://github.com/esaia/bible',
    img: './images/bible.jpg',
    websiteURL: 'https://bibleversesgeo.netlify.app/',
    skills: ['React', 'React Select', 'cacheing', 'React Query', 'Tailwind css', 'Framer Motion'],
    description:
      'The BibleVerse Projector App is a user-friendly application designed to display Bible verses on projectors or large screens in 3 different languages: Georgian, English and Russian at the same time.',
  },

  {
    title: 'Movies App',
    githubURL: 'https://github.com/esaia/tmdb-movie',
    img: './images/qmovies.jpg',
    websiteURL: 'https://tmdb-allmovie.netlify.app/',
    skills: ['NextJs 14', 'SSR', 'Tailwind css', 'TMDB Api', 'cacheing'],
    description:
      'A modern movie discovery app built using Next.js 14 with Server-Side Rendering (SSR). The app fetches movie data from the TMDB API to display movies, trailers, and additional media content.',
  },

  {
    title: 'Country Information Application',
    githubURL: 'https://github.com/esaia/country_api',
    websiteURL: 'https://jovial-pudding-a683e7.netlify.app',
    img: './images/country.jpg',
    skills: ['React', 'cacheing', 'react-query', 'Tailwind css', 'MUI (Material-UI)'],
    description:
      'This app has information about different Countries and their airports. Built with React and MUI (Material-UI). The application uses caching to avoid send many requests. ',
  },

  {
    title: 'Epic Movie Quote (front)',
    githubURL: 'https://github.com/esaia/epic-movie-front',
    img: './images/epic-movie.jpg',
    skills: ['Next Js', 'React Query', 'TypeScript', 'Pusher', 'React hook form'],
    description:
      'This is a movie quote website built with Next.js. Users can engage with the website by liking and commenting. Users can choose their preferred language to read quotes in Georgia or English. The website provides Google authentication ',
  },

  {
    title: 'Epic Movie Quote (back)',
    githubURL: 'https://github.com/esaia/epic-movie-back',
    img: './images/epic-movie.jpg',
    skills: ['laravel', 'Pusher', 'laravel broadcasting', 'Google auth'],
    description:
      'This app built using Laravel. Users can add movies/quotes, and engage in discussions by leaving comments. Users have the ability to update their email passwords ',
  },

  {
    title: 'CV generator',
    githubURL: 'https://github.com/esaia/cv-generator-Bootcamp',
    img: './images/cv.jpg',
    websiteURL: 'https://ubiquitous-axolotl-9bbb2b.netlify.app/',
    skills: [],
    description: 'This user-friendly web app simplifies the creation of professional CVs.',
  },
  {
    title: 'Covid Questionare',
    githubURL: 'https://github.com/esaia/covid-questionare',
    img: './images/covid-questionare.jpg',
    websiteURL: 'https://covid-questionare-redberry.netlify.app/',
    skills: ['React', 'React hook form', 'Framer Motion'],
    description:
      'The COVID-Questionnaire website is a user-friendly platform designed to help individuals assess their potential risk of COVID-19 infection.',
  },

  {
    title: 'Coronatime',
    githubURL: 'https://github.com/esaia/coronatime',
    img: './images/dashboard.jpg',
    skills: ['php', 'laravel', 'laravel blades'],
  },

  {
    title: 'Color Picker',
    githubURL: 'https://github.com/esaia/Color-Picker',
    websiteURL: 'https://precious-banoffee-c15560.netlify.app/',
    img: './images/colorPicker.jpg',
    skills: ['color-picker', 'Tailwind css', 'framer-motion', 'animations'],
  },

  {
    title: 'Airbnb Clone 2.0',
    githubURL: 'https://github.com/esaia/Airbnb-clone',
    img: './images/airbnb.jpg',
    websiteURL: 'https://jovial-pudding-a683e5.netlify.app/',
    skills: ['React', 'react-date-range', 'react-router-dom', 'date-fns'],
    description: 'Airbnb Clone 2.0, powered by React.',
  },

  {
    title: 'Blog',
    githubURL: 'https://github.com/esaia/blog_mysql',
    websiteURL: 'https://github.com/esaia/blog_mysql',
    img: './images/blog.jpg',
    skills: ['NodeJS', 'express', 'mysql', 'sass', 'jwt', 'bcrypt'],
  },

  // {
  //   title: 'Adjaranet Clone 2.0',
  //   githubURL: 'https://github.com/esaia/adjaranet-clone',
  //   websiteURL: 'https://adjaranet-clone.netlify.app/',
  //   img: './images/adjaranet.jpg',
  //   skills: ['React', 'TMDB', 'Axios', 'Slick slider', 'swiper'],
  //   description:
  //     'Adjaranet Clone Website built with react. I am using TBDB api to fetch the movies, and swiper slider for display them',
  // },
  // {
  //   title: 'Realtime Chat App',
  //   description: 'Email: jack@gmail.com Password: 123123',
  //   githubURL: 'https://github.com/esaia/Chat_App',
  //   img: './images/chat.jpg',
  //   websiteURL: 'https://realtimechatappwithreact.netlify.app/',
  //   skills: ['Firebase', 'Tailwind css', 'realTime', 'Firebase'],
  // },

  // {
  //   title: 'Documentation Website',
  //   githubURL: 'https://github.com/esaia/Documentation',
  //   websiteURL: 'https://aesthetic-axolotl-c60cdd.netlify.app/',
  //   img: './images/documentation.jpg',
  //   skills: ['scss', 'animations', 'doc'],
  // },

  // {
  //   title: 'Store Ecommerce',
  //   githubURL: 'https://github.com/esaia/Store',
  //   websiteURL: 'https://reduxstorerwithreact.netlify.app/',
  //   img: './images/store.jpg',
  //   skills: ['Redux', 'redux toolk', 'store', 'pagination'],
  // },

  // {
  //   title: 'Slot ',
  //   githubURL: 'https://github.com/esaia/slots',
  //   websiteURL: 'https://merry-macaron-48d5fd.netlify.app/',
  //   img: './images/slots.jpg',
  //   skills: ['Vanilla JavaScript', 'slots', 'random numbers'],
  // },

  // {
  //   title: 'Multiple Selector (typescreapt)',
  //   githubURL: 'https://github.com/esaia/multiple-select',
  //   websiteURL: 'https://luxury-nougat-73e86a.netlify.app/',
  //   img: './images/multiselect.jpg',
  //   skills: ['React', 'typescreapt'],
  // },

  // {
  //   title: 'To Do List',
  //   githubURL: 'https://github.com/esaia/To-Do-List',
  //   websiteURL: 'https://to-do-project-react.netlify.app/',
  //   img: './images/todoapp.jpg',
  //   skills: ['React', 'useContext', 'Todo', 'LocalStorage'],
  // },

  // {
  //   title: 'To Do App',
  //   description: 'Todo app with VueJS',
  //   githubURL: 'https://github.com/esaia/todo-vue',
  //   websiteURL: 'https://candid-mousse-29ab4f.netlify.app/',
  //   img: './images/mytodo.jpg',
  //   skills: ['Vue', 'API', 'Todo'],
  // },

  // {
  //   title: 'Password Generator',
  //   githubURL: 'https://github.com/esaia/Password_generator',
  //   websiteURL: 'https://esaia.github.io/Password_generator/',
  //   img: './images/passgenerator.jpg',
  //   skills: ['Vanilla JavaScript'],
  // },

  // {
  //   title: 'Publish Post',
  //   githubURL: 'https://github.com/esaia/post-publisher-Redux-',
  //   websiteURL: 'https://publishnewposts.netlify.app/',
  //   img: './images/postspublish.jpg',
  //   skills: ['Redux', 'redux toolk', 'localStorage'],
  // },
];

export const careerData = [
  {
    title: 'Money Alive - video canvas',
    websiteURL: 'https://www.videocanvas.co.uk/',
  },

  {
    title: 'Telasi',
    websiteURL: 'https://www.telasi.ge/',
  },
  {
    title: 'Telasi Cabinet',
    websiteURL: 'https://www.telasi.ge/cabinet',
  },
  {
    title: 'Silknet',
    websiteURL: 'https://silknet.com/',
  },
  {
    title: 'BasisBank',
    websiteURL: 'https://bb.ge/',
  },
  {
    title: 'Tbc wm',
    websiteURL: 'https://tbcwm.ge/',
  },
  {
    title: 'Simetria',
    websiteURL: 'http://simetria.ge/',
  },

  {
    title: 'Gumbati',
    websiteURL: ' https://gumbati.ge/ka',
  },

  {
    title: 'Axistowers',
    websiteURL: 'https://axistowers.ge/',
  },
  {
    title: 'Gpih',
    websiteURL: 'https://www.gpih.ge/ka',
  },

  {
    title: 'My Water',
    websiteURL: 'https://mywatershop.ge/ge',
  },

  {
    title: 'CMC hospital',
    websiteURL: 'https://www.cmchospital.ge/ge',
  },
];

export const socialLinks = [
  {
    link: 'https://x.com/esaia__',
    icon: <FaSquareXTwitter />,
  },
  { link: 'https://github.com/esaia', icon: <FaGithub /> },
  {
    link: 'https://www.linkedin.com/in/esaia-gaprindashvili-7219771a9/',
    icon: <FaLinkedin />,
  },
];

export const skills = {
  front: ['TypeScript', 'React Js', 'React Native', 'Next Js', 'Vue Js', 'Nuxt Js'],

  back: ['PHP', 'Laravel'],
  style: ['Tailwind css', 'Scss'],
  database: ['MySQL', 'Firebase'],
  'version Control': ['Git', 'GitHub', 'GitLab'],
  'content Management': ['WordPress', 'WP plugin development', 'Filament'],
  'operating System': ['macOS', 'Linux'],
};
